import React from "react";
import { Environment } from "@react-three/drei";

const Lighting = () => {
  return (
    <>
      <Environment preset="sunset" />
    </>
  );
};

export default Lighting;
